<template>
  <BaseCheckboxListItem
    :title="title"
    :description="description"
    :selected="selected"
    icon="school"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import BaseCheckboxListItem from '@/core/components/base/list-item/BaseCheckboxListItem.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import { memberFullName } from '@/core/models/member/member-name'
  import type { KompetenzprofilLesson, MemberViewModel } from '../models/kompetenzprofil'

  const props = defineProps<{
    lesson: KompetenzprofilLesson
    teachers: ReadonlyArray<MemberViewModel>
    selected: boolean
  }>()

  const { t } = useI18n()
  const endedAtLabel = props.lesson.endedAt
    ? useDisplayDate(props.lesson.endedAt, { dayName: 'short', monthName: 'short' })
    : computed(() => '')

  const title = computed(() => props.lesson.lessonImpulseTitle ?? t('lumia.lesson.impulseMissing'))

  const description = computed(() => {
    const teacher = props.teachers.find((member) => member.id === props.lesson.teacherId)
    return [endedAtLabel.value, teacher ? memberFullName(teacher) : '']
      .filter((part) => part.length > 0)
      .join(' · ')
  })
</script>
